import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-jc-center" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_3 = { class: "p-column-filter" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_CurrencyText = _resolveComponent("CurrencyText")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _directive_date_format = _resolveDirective("date-format")!

  return (_openBlock(), _createBlock(_component_DataTable, _mergeProps({
    lazy: true,
    loading: _ctx.isLoading,
    value: _ctx.reports,
    rows: 10,
    paginator: true,
    "rows-per-page-options": [10, 20, 50, 100],
    totalRecords: _ctx.totalRecords,
    filterDisplay: "row",
    stripedRows: "",
    responsiveLayout: "scroll",
    onPage: _ctx.onPage,
    onFilter: _ctx.onFilter,
    ref: "table"
  }, _ctx.$attrs), {
    header: _withCtx(() => [
      _createVNode(_component_Button, {
        label: "Export",
        icon: "pi pi-file-excel",
        class: "p-button-outlined",
        onClick: _ctx.onExportClick
      }, null, 8, ["onClick"])
    ]),
    empty: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('billing_customers.empty_message')), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Column, {
        field: "id",
        header: "ID"
      }),
      _createVNode(_component_Column, {
        header: "Tipo",
        field: "type",
        showFilterMatchModes: false,
        showFilterMenu: false
      }, {
        body: _withCtx(({ data: { type } }) => [
          _createTextVNode(_toDisplayString(_ctx.$t(`billing_customers.type_${type}`)), 1)
        ]),
        filter: _withCtx(({ filterModel, filterCallback }) => [
          _createVNode(_component_MultiSelect, {
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
            options: _ctx.billingTypeOptions,
            optionLabel: "label",
            optionValue: "value",
            placeholder: "Tipo",
            onChange: filterCallback
          }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
        ]),
        _: 1
      }),
      _createVNode(_component_Column, {
        header: "Nome",
        field: "business_name",
        showFilterMatchModes: false,
        showFilterMenu: false,
        style: { minWidth: '12rem' }
      }, {
        filter: _withCtx(({ filterModel, filterCallback }) => [
          _createVNode(_component_InputText, {
            type: "text",
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
            class: "p-column-filter",
            placeholder: "Nome",
            onChange: filterCallback,
            onKeyup: _withKeys(filterCallback, ["enter"])
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "onKeyup"])
        ]),
        _: 1
      }),
      _createVNode(_component_Column, {
        header: "Periodo",
        filterField: "period",
        style: _normalizeStyle([{"min-width":"15rem"}, { minWidth: '20rem' }]),
        showFilterMatchModes: false,
        showFilterMenu: false
      }, {
        body: _withCtx(({ data: { date_from_at, date_to_at } }) => [
          _withDirectives(_createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(date_from_at), 1)
          ], 512), [
            [_directive_date_format]
          ]),
          _hoisted_2,
          _withDirectives(_createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(date_to_at), 1)
          ], 512), [
            [_directive_date_format]
          ])
        ]),
        filter: _withCtx(({ filterModel, filterCallback }) => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Calendar, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              selectionMode: "range",
              manualInput: false,
              showIcon: true,
              placeholder: "Periodo",
              dateFormat: "dd/mm/yy",
              onDateSelect: ($event: any) => (_ctx.updatePeriod(filterModel.value, filterCallback))
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onDateSelect"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Column, {
        header: "Note",
        field: "note"
      }),
      _createVNode(_component_Column, {
        header: "Totale",
        headerClass: "column-header-right",
        class: "p-text-right",
        field: "total_amount"
      }, {
        body: _withCtx(({ data }) => [
          _createVNode(_component_CurrencyText, {
            modelValue: data.total_amount
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_Column, null, {
        body: _withCtx(({data}) => [
          _createVNode(_component_Button, {
            icon: "pi pi-pencil",
            onClick: ($event: any) => (_ctx.$emit('edit', {...data}))
          }, null, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 16, ["loading", "value", "totalRecords", "onPage", "onFilter"]))
}